<template>
  <div>
      <v-toolbar color="#000000" dark dense>
      <v-spacer v-show="!$vuetify.breakpoint.xs"></v-spacer>
      <v-toolbar-items>
          <v-btn :class="$vuetify.breakpoint.xs?'icon_size':''" class="button_font" flat to="/dashboard">  <v-icon :class="$vuetify.breakpoint.xs?'icon_size':''"  class="pr-2">account_balance</v-icon>Dashboard</v-btn>
          <v-btn v-if="userpermission.syndcation_manager" :class="$vuetify.breakpoint.xs?'icon_size':''" class="button_font" flat to="/super-syndicate"><v-icon :class="$vuetify.breakpoint.xs?'icon_size':''" class="pr-2">account_tree</v-icon>Super Syndicate</v-btn>
          <v-btn :class="$vuetify.breakpoint.xs?'icon_size':''" class="button_font" flat to="/profile"><v-icon :class="$vuetify.breakpoint.xs?'icon_size':''" class="pr-2">account_box</v-icon>My Profile</v-btn>
          <v-btn :class="$vuetify.breakpoint.xs?'icon_size':''" class="button_font" flat @click="logout" ><v-icon :class="$vuetify.breakpoint.xs?'icon_size':''" class="pr-2">exit_to_app</v-icon> Logout</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import { URL } from '../../env'

export default {
  data() {
    return {
      userpermission: {},
    };
  },
  mounted() {
    this.getUserPermission();
  },
  methods:{
    getUserPermission(){
      const userId = localStorage.getItem('user_id');
      if (!userId) return;
      axios.get(`${URL}/api/user_permission/user_permissions/${userId}`)
        .then(res => { this.userpermission = res.data.length > 0 ? res.data[0] : {}; });
    },
    logout(){
      let lastSyndId = localStorage.getItem('last_syndication_id')
      let rememberMe = localStorage.getItem('remember_me')
      localStorage.clear()
      if(rememberMe){
        localStorage.setItem('remember_me', rememberMe)
      }
      if(lastSyndId && lastSyndId != 'null'){
        localStorage.setItem('last_syndication_id', lastSyndId)
      }
      this.$router.push('/login');
    }
  },
};
</script>

<style scoped>

.button_font {
  font-weight:bold;
}
.icon_size{
  font-size: 12px !important;
}
</style>